import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import ButtonComponent from "../button/ButtonComponent";

interface ZoomInImageProps {
  imageUrl: string;
  alt: string;
  visibleModal: boolean;
  setVisibleModal: (visible: boolean) => void;
}

/**
 * ZoomInImage component displays an image inside a centered Material UI Modal.
 * @param {object} props - The component props.
 * @param {string} props.imageUrl - The URL of the image to display.
 * @param {boolean} props.visibleModal - Controls the visibility of the modal.
 * @param {(visible: boolean) => void} props.setVisibleModal - Function to set the modal's visibility.
 * @param {string} props.alt - Alternative text for the image.
 */
export default function ZoomInImage({
  imageUrl,
  visibleModal,
  setVisibleModal,
  alt,
}: ZoomInImageProps) {
  const handleClose = () => {
    setVisibleModal(false);
  };
  return (
    <Modal
      open={visibleModal}
      onClose={handleClose}
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          boxShadow: 'none',
          border: 'none',
          outline: 'none',
          bgcolor: 'background.paper',
          textAlign: "center",
          p: 4,
          width: { xs: "90%", sm: "80%", lg: "40%" },
          height: { md: "70%" },
          borderRadius: 4,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          gap: 3
        }}
      >
        <Box sx={{ height: "82%" }}>
          <img src={imageUrl} width="100%" height="100%" alt={alt} />
        </Box>
        <ButtonComponent
          label="閉じる"
          onClick={handleClose}
          sx={{
            width: "auto",
            px: 3,
            mx: "auto",
            borderRadius: 1.5,
          }}
          theme="default"
        />
      </Box>
    </Modal>
  );
}
